module.exports = __webpack_public_path__ + "static/media/back-new-5.d0a21201.jpg";